import { matchPath } from 'react-router-dom';

/**
 * Which of a set of sibling nav paths is the current one — at most ONE.
 *
 * A row is current when its path is the pathname or a segment-prefix of it, so
 * `/payments` stays lit on `/payments/:id`. When two siblings both match — one
 * is a prefix of the other, as `/payments` is of `/payments/events` — the longer
 * wins, because that is where the operator actually is. `/` prefixes everything
 * and is matched exactly.
 */
export function resolveActiveNavPath(
  paths: readonly string[],
  pathname: string,
): string | undefined {
  let active: string | undefined;

  for (const path of paths) {
    const matches = matchPath({ path, end: path === '/' }, pathname) !== null;
    if (matches && (active === undefined || path.length > active.length)) {
      active = path;
    }
  }

  return active;
}
